/**
 * Fatiado de lib/api.ts por domínio (#131, regra R3).
 */
import { get, post } from './client.js'
// ─── Payments — Stripe Connect do restaurante (features/payments, #160) ──────

export type ConnectStatusDto = {
  connected: boolean
  account_id: string | null
  charges_enabled: boolean
  payouts_enabled: boolean
  details_submitted: boolean
  country: string | null
  currency: string | null
  ready: boolean
  country_caveat: string | null
  onboarding_started_at: number | null
  updated_at: number | null
}

export const paymentsApi = {
  /** Link de onboarding (conta Express criada na 1ª chamada). */
  connect: (returnUrl: string) =>
    post<{ onboarding_url: string; account_id: string }>('/admin/payments/connect', {
      return_url: returnUrl,
    }),
  status: () => get<ConnectStatusDto>('/admin/payments/status'),
}
